import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";
import { apiRequest } from "../api/apiRequest";

import Loading from "../components/Loading";
import Navbar from "../components/Navbar";
import SideMenu from "../components/SideMenu";

function Notificacoes() {
    const [notificacoes, setNotificacoes] = useState([]);
    const [dataDe, setDataDe] = useState("");
    const [dataAte, setDataAte] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [hasMore, setHasMore] = useState(true);
    const debounceTimeoutRef = useRef(null);

    const fetchNotificacoes = async () => {
        setLoading(true);
        setError(null);
        setHasMore(true);

        const params = {
            pagina: page,
            limite_quantidade: itemsPerPage,
        };

        if (dataDe) params.data_de = dataDe;
        if (dataAte) params.data_ate = dataAte;

        try {
            const response = await apiRequest("GET", "/notificacoes", "", params);
            setNotificacoes(response.data.data || []);
            setHasMore(response.data.data?.length === itemsPerPage);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    const marcarComoLida = async (id) => {
        try {
            await apiRequest("PUT", `/notificacoes/${id}/marcar-lida`);
            fetchNotificacoes();
        } catch (err) {
            console.error("Erro ao marcar como lida:", err);
        }
    };

    const marcarTodasComoLidas = async () => {
        try {
            await apiRequest("PUT", `/notificacoes/marcar-todas-lidas`);
            fetchNotificacoes();
        } catch (err) {
            console.error("Erro ao marcar todas como lidas:", err);
        }
    };

    const limparFiltros = () => {
        setDataDe("");
        setDataAte("");
        fetchNotificacoes();
    };

    const formatTimeAgo = (dateString) => {
        const date = new Date(dateString);
        const now = new Date();
        const diffMs = now - date;

        const seconds = Math.floor(diffMs / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);

        if (days > 0) return `${days} dia${days > 1 ? "s" : ""} atrás`;
        if (hours > 0) return `${hours} hora${hours > 1 ? "s" : ""} atrás`;
        if (minutes > 0) return `${minutes} minuto${minutes > 1 ? "s" : ""} atrás`;
        return "Agora mesmo";
    };

    useEffect(() => {
        if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);

        debounceTimeoutRef.current = setTimeout(() => {
            fetchNotificacoes();
        }, 800);

        return () => clearTimeout(debounceTimeoutRef.current);
    }, [dataDe, dataAte]);

    useEffect(() => {
        fetchNotificacoes();
    }, [page, itemsPerPage]);

    const startItem = page * itemsPerPage + 1;
    const endItem = startItem + notificacoes.length - 1;

    const todasLidasNaPagina = notificacoes.every(item => item.lido === 1);

    return (
        <div id="wrapper" style={{ backgroundColor: "#043A5E" }}>
            <SideMenu />

            <div id="page-wrapper" style={{ backgroundColor: "#FCFCFD" }}>
                <Navbar />

                <div className="wrapper wrapper-content">
                    <div className="d-flex justify-content-between">
                        {/* Filtros */}
                        <div
                            className="border-0 shadow-sm bg-white p-4"
                            style={{ borderRadius: "1rem", width: "25%" }}
                        >
                            <div className="mb-4" style={{ fontSize: "25px", fontWeight: "600" }}>
                                Filtros
                            </div>

                            <div className="form">
                                <label className="control-label mt-2">Data</label>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "10px",
                                        marginTop: "2px",
                                    }}
                                >
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <span style={{ width: "30px" }}>De:</span>
                                        <input
                                            type="date"
                                            value={dataDe}
                                            onChange={(e) => setDataDe(e.target.value)}
                                            style={{
                                                width: "100%",
                                                padding: "13px",
                                                border: "1px solid #E5E7EB",
                                                borderRadius: "7px",
                                                fontSize: "14px",
                                                color: "#6C737F",
                                            }}
                                        />
                                    </div>

                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <span style={{ width: "30px" }}>Até:</span>
                                        <input
                                            type="date"
                                            value={dataAte}
                                            onChange={(e) => setDataAte(e.target.value)}
                                            style={{
                                                width: "100%",
                                                padding: "13px",
                                                border: "1px solid #E5E7EB",
                                                borderRadius: "7px",
                                                fontSize: "14px",
                                                color: "#6C737F",
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="d-flex justify-content-start mt-4">
                                    <button className="btn btn-primary" onClick={limparFiltros}>
                                        Limpar filtros
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Lista de Notificações */}
                        <div style={{ width: "73%" }}>
                            <div className="w-100">
                                <div className="d-flex justify-content-between align-items-center mt-4 mb-4 w-100">
                                    <div
                                        className="pl-4"
                                        style={{ fontSize: "34px", fontWeight: "600" }}
                                    >
                                        Notificações
                                    </div>

                                    <button
                                        className="btn btn-success"
                                        onClick={marcarTodasComoLidas}
                                        disabled={notificacoes.length === 0 || todasLidasNaPagina}
                                    >
                                        Marcar todas como lidas
                                    </button>
                                </div>

                                <div className="bg-white p-3" style={{ borderRadius: "1rem" }}>
                                    {loading && (
                                        <div style={{ textAlign: "center", padding: "20px" }}>
                                            <Loading />
                                        </div>
                                    )}

                                    {error && (
                                        <div style={{ textAlign: "center", padding: "20px" }}>
                                            Erro: {error.message}
                                        </div>
                                    )}

                                    {!loading && notificacoes.length === 0 && !error && (
                                        <div style={{ textAlign: "center", padding: "20px" }}>
                                            Nenhuma notificação encontrada
                                        </div>
                                    )}

                                    {!loading &&
                                        !error &&
                                        notificacoes.map((item) => (
                                            <div
                                                key={item.id}
                                                className="d-flex justify-content-between align-items-center border-bottom py-3"
                                                style={{
                                                    opacity: item.lido === 1 ? 0.8 : 1,
                                                    backgroundColor: item.lido === 0 ? "#FFFACD" : "transparent",
                                                    borderLeft: item.lido === 0 ? "4px solid #FFD700" : "none",
                                                    paddingLeft: "0.5rem",
                                                }}
                                            >
                                                <div>
                                                    <a
                                                        href={item.url_destino}
                                                        style={{ color: "#232730" }}
                                                    >
                                                        <div>{item.descricao}</div>
                                                    </a>
                                                    <small className="text-muted">{formatTimeAgo(item.criado)}</small>
                                                </div>

                                                {
                                                    item.lido === 0 && (
                                                        <button
                                                            className="btn btn-primary mr-2"
                                                            onClick={() => marcarComoLida(item.id)}
                                                        >
                                                            Marcar como lida
                                                        </button>
                                                    )
                                                }
                                            </div>
                                        ))}
                                </div>

                                {/* Paginação */}
                                <div className="d-flex justify-content-end align-items-center py-2">
                                    <div className="mr-4">Itens por página</div>

                                    <select
                                        className="mr-4"
                                        style={{ border: "none" }}
                                        value={itemsPerPage}
                                        onChange={(e) => {
                                            setItemsPerPage(parseInt(e.target.value));
                                            setPage(0);
                                        }}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                    </select>

                                    <div className="mr-4">
                                        Exibindo {startItem}-{endItem}
                                    </div>

                                    <div
                                        className="mr-4"
                                        style={{
                                            fontSize: "20px",
                                            cursor: page === 0 ? "default" : "pointer",
                                            opacity: page === 0 ? 0.5 : 1,
                                        }}
                                        onClick={() => page > 0 && setPage(page - 1)}
                                    >
                                        <RiArrowLeftSLine />
                                    </div>

                                    <div
                                        className="mr-4"
                                        style={{
                                            fontSize: "20px",
                                            cursor: hasMore ? "pointer" : "default",
                                            opacity: hasMore ? 1 : 0.5,
                                        }}
                                        onClick={() => hasMore && setPage(page + 1)}
                                    >
                                        <RiArrowRightSLine />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default Notificacoes;